import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ColumnExportButton, Table } from 'barnyard/components';

const columns = [{
  Header: 'Date Created',
  id: 'date',
  accessor: row => moment(row.date).format('MMMM Do, YYYY'),
  width: 150
}, {
  Header: 'External ID',
  accessor: 'external_id',
  width: 150,
}, {
  Header: 'Item Name',
  accessor: 'item_name',
}];


const CorporateLinkItemTable = ({ items, includeExport }) => (
  <Table
    actions={includeExport && (
      <div className='u-paddingTop10'>
        <ColumnExportButton
          filename='Vetcove_Link_Items.csv'
          columns={columns}
          data={items}
        >
          Download
        </ColumnExportButton>
      </div>
    )}
    size='small'
    columns={columns}
    data={items}
    pageSize={_.size(items) || 10}
    showPagination={false}
  />
);

CorporateLinkItemTable.propTypes = {
  items: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default CorporateLinkItemTable;